import React from "react";

import FileQuestionIcon from "@uui/FileQuestion03";
import { isEmpty, toLower } from "lodash/fp";

import { RANGE_PRESETS } from "@app/analytics/components/DateSelector/utils";
import { TableCell, TableRow } from "@app/analytics/components/Table";
import useReportsTable from "@app/analytics/MeetingReports/stores/reportsTable";
import useDateRangeStore from "@app/analytics/stores/useDateRangeStore";
import ROUTES from "@app/common/routes";

import Button from "@rui/Button";
import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtext,
  EmptyStateTitle,
} from "@rui/EmptyStateContainer";
import { Link } from "@rui/Link";

import { getEmptyStateOpts } from "./utils";

const ReportsTableEmptyState = () => {
  const [dateRangePreset, setDateRangePreset] = useDateRangeStore((state) => [
    state.dateRangePreset,
    state.setDateRangePreset,
  ]);

  const hasAppliedFilters = useReportsTable((state) => {
    const hasTagFiltersApplied =
      !isEmpty(state.tags.selectedTags) &&
      state.tags.selectedTags.length < state.tags.all.length;
    const hasSourceFiltersApplied =
      !isEmpty(state.sources.selected) &&
      state.sources.selected.length < state.sources.all.length;
    return (
      state.reportViews.length < 2 ||
      hasTagFiltersApplied ||
      hasSourceFiltersApplied
    );
  });

  const { title, subtitle, suggestedPreset } = getEmptyStateOpts({
    selectedPreset: dateRangePreset,
    hasAppliedFilters,
  });

  return (
    <TableRow>
      <TableCell colSpan={100} sx={{ whiteSpace: "wrap" }}>
        <EmptyStateContainer sx={{ height: "440px" }}>
          <EmptyStateIcon Icon={FileQuestionIcon} />
          <EmptyStateTitle>{title}</EmptyStateTitle>
          <EmptyStateSubtext>{subtitle}</EmptyStateSubtext>
          {suggestedPreset ? (
            <Button
              variant="gradient"
              onClick={() => setDateRangePreset(suggestedPreset)}
            >
              Search {toLower(RANGE_PRESETS[suggestedPreset])}
            </Button>
          ) : hasAppliedFilters ? null : (
            <Button variant="gradient" component={Link} to={ROUTES.CALENDAR}>
              View upcoming meetings
            </Button>
          )}
        </EmptyStateContainer>
      </TableCell>
    </TableRow>
  );
};

export default ReportsTableEmptyState;
